import { httpService } from '@/api/v1/http.service'
import useDownload, { type DownloadParams } from '@/hooks/useDownload'
import { type StudentsParams } from '@/queries/useStudents'
import { parseColumnsToFetchKeys } from '@/utils/parse-columns-to-fetch-keys'

type Params = DownloadParams & StudentsParams
const useStudentsDownload = (studentsDownloadParams: Params) =>
  useDownload({
    fileName: 'students',
    requestParams: studentsDownloadParams,
    // @ts-expect-error Waits for backend fix - file type should be returned
    downloadMutation: (params: Params) =>
      httpService.panel.panelStudentsList(
        {
          format: params.format,
          search: params.search,
          academic_level_id: params.academicLevelId,
          class_id: params.classId,
          tutor_id: params.tutor,
          parent_id: params.parent,
          status: params.status,
          group_id: params.groupId,
          fetchKeys: parseColumnsToFetchKeys(params.columnsKey, params.format)
        },
        { format: 'blob' }
      )
  })

export default useStudentsDownload
